import type { ReactNode } from "react";
import type { Translate } from "./types.js";

/** Loading placeholder for a page or card. */
export function Loading(props: { t: Translate; label?: string }): ReactNode {
  return (
    <div className="state" role="status" aria-live="polite">
      <span className="spinner" aria-hidden="true" />
      <span>{props.label ?? props.t("ui.state.loading")}</span>
    </div>
  );
}

/** Calm empty state with an optional hint and action. */
export function EmptyState(props: {
  t: Translate;
  title?: string;
  hint?: string;
  action?: ReactNode;
}): ReactNode {
  return (
    <div className="state">
      <p>{props.title ?? props.t("ui.state.empty")}</p>
      {props.hint ? <p className="small">{props.hint}</p> : null}
      {props.action}
    </div>
  );
}

/** Error state with a retry button when `onRetry` is given. */
export function ErrorState(props: {
  t: Translate;
  message?: string;
  onRetry?: () => void;
}): ReactNode {
  return (
    <div className="state state-error" role="alert">
      <p>{props.message ?? props.t("ui.state.error")}</p>
      {props.onRetry ? (
        <button type="button" className="btn btn-sm" onClick={props.onRetry}>
          {props.t("ui.state.retry")}
        </button>
      ) : null}
    </div>
  );
}
